import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { useMutation } from '@apollo/react-hooks'
import { useAlert } from '@xti-external/frontend-kit-components'

import { ALERT_SIZE_MAPPING } from '~/config/screen'
import MUTATION_RESET_PASSWORD from '~/queries/auth/resetPassword'
import { customDelay as delay } from '~/utils/interval'

const useCustom = ({ screen }) => {
  const history = useHistory()
  const { handleOpenSnackbar } = useAlert()

  const [resetPassword] = useMutation(MUTATION_RESET_PASSWORD)

  const handleBack = useCallback(() => {
    history.push({
      pathname: '/',
    })
  }, [])

  const handleSubmit = useCallback(async (values, { resetForm }) => {
    let errorData = {}
    if (values.email) {
      const data = {
        email: values.email,
        resetCode: '',
        newPass: '',
      }
      await resetPassword({
        variables: {
          resetPassData: data,
        },
      }).catch((err) => {
        errorData = JSON.parse(err.message)
        if (errorData.detail) {
          handleOpenSnackbar({
            size: ALERT_SIZE_MAPPING[screen],
            testid: 'error-reset-password-alert',
            title: `${errorData.code}: ${errorData.detail}`,
            variant: 'error',
          })
          resetForm()
        }
      })
      if (!errorData.detail) {
        handleOpenSnackbar({
          duration: 2000,
          size: ALERT_SIZE_MAPPING[screen],
          testid: 'success-reset-password-alert',
          title:
            'Password Reset Confirmation Successfully Sent, Please Check Your Email',
          variant: 'success',
        })
        resetForm()
        await delay(2000)
        history.push('/')
      }
    } else {
      handleOpenSnackbar({
        size: ALERT_SIZE_MAPPING[screen],
        testid: 'fail-reset-password-alert',
        title: 'Request Reset Password Failed: Please fill the Email Address',
        variant: 'error',
      })
    }
  }, [])

  return {
    handler: {
      handleBack,
      handleSubmit,
    },
  }
}
export default useCustom
